<!-- Shop products -->
<section>
    <div class="container-fluid">

        <div class="heading m-b-0">
            <h3>{{titolo}}</h3>
        </div>

        <!--Product list-->
        <div class="shop"> 
            <div style="display: flex; vertical-align: middle; padding-bottom: 10px;">
                <span class="material-icons icoView" *ngIf="typeVis == 'icon' && page != 'home'" (click)="changeVis('list')">
                    view_headline
                    </span>
                    <span class="material-icons icoView" *ngIf="typeVis == 'list'  && page != 'home'" (click)="changeVis('icon')">
                        grid_view
                        </span>
    
                        <span style="font-size: 16px;" *ngIf="page != 'home'">Ordina per: <a  (click)="sortClick.emit('titolo')" style="cursor:pointer; color: #007bff;"> Alfabetico</a> <a (click)="sortClick.emit('nrigaoff')" style="cursor:pointer; color: #007bff;"> Riga</a> <a (click)="sortClick.emit('prezzo_scontato_ie')" style="cursor:pointer; color: #007bff;"> Prezzo</a></span>
            </div>
            
            <div class="row">
                
                <!-- INIZIO SINGOLO PRODOTTO -->
                <ng-container *ngIf="typeVis == 'icon'">
                    <div class="col-xl-3 col-lg-4 col-md-6 col-6 " *ngFor="let prodotto of arrProdotti, let i = index">
                        <div class="product" [ngStyle]="{'border-color':prodotto.tipoprod == 'c' ? '#FF7F50' : prodotto.tipoprod == 'v' ? '#008000' : '#6ebbda' }    ">
                            
                                <a  (click)="openModal(prodotto.idprod); $event.stopPropagation();"><img alt="Nome immagine" src="{{prodotto.img1}}">
                                </a>

                                <span class="product-promo" *ngIf="prodotto.InPromo != 0 && pageCurProd != 'volantino-dettaglio'" (click)="openModal(prodotto.InPromo);">
                                    PROMO
                                   </span>

                                    <span class="product-new" *ngIf="prodotto.inCarrello != 0">
                                        <i class="icon-shopping-cart icoCartProd"></i>
                                        <span class="elCart">{{prodotto.inCarrello}}</span></span>
                                <!-- <span class="product-wishlist">
                                    <a href="#"><i class="fa fa-heart"></i></a>
                                </span> -->
                                <!-- <div class="product-overlay">
                                    <a [routerLinkActive]="['active']" [routerLink]="['/schedaProdotto', prodotto.idprod]" >Scopri di più</a>
                                </div> -->
                            
    
                            <div class="product-description">
                                <div class="cart-product-quantity qty-box" *ngIf="loggato && prodotto.vendibile == 1">
                                    <div class="quantity">
                                        <input type="button" class="minus" value="-" (click)="removeQty(i)">
                                        <input type="text" class="qty" value="1" name="quantity" [(ngModel)]="prodotto.qty">
                                        <input type="button" class="plus" value="+" (click)="addQty(i)">
                                    </div>
                                    <a class="btn" (click)="addCart(prodotto, i)"><span class="material-icons icoCart">
                                        add_shopping_cart
                                        </span></a>
                                </div>
                                
    
                                    <!-- <a class="btn btn-block mt-3 danger" *ngIf="loggato"  (click)="addCart(prodotto)">Aggiungi al carrello</a> -->
                              
                                
                                <button class="btn btn-block mt-3 btn-danger" routerLink="/accedi" *ngIf="!loggato">ACCEDI</button>
                                <h3 class="titolo-prodotto"><a (click)="openModal(prodotto.idprod)">{{prodotto.titolo}}</a></h3>
                                <div style="margin-bottom: 5px;min-height: 45px;"><h4 class="ean-prodotto" style="color: #6ebbda;font-weight: 700;" *ngIf="prodotto.testoPromo">{{prodotto.testoPromo}}</h4></div>
                                <h4 class="ean-prodotto">EAN: {{prodotto.ean}}</h4>
                                <h4 class="ean-prodotto">Cartone: {{prodotto.cartone}} pz</h4>
                                <h4 class="ean-prodotto" *ngIf="prodotto.tipoprod == 'c'">&nbsp; Canvas e Listino</h4>
                                <h4 class="ean-prodotto" *ngIf="prodotto.tipoprod == 'v'">&nbsp;Volantino</h4>
                                <div class="product-title" *ngIf="loggato">
                                    <img src="./assets/images/Semaforo-arancio.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita >= 1 && prodotto.disponibilita <= 10">
                            <img src="./assets/images/Semaforo-verde.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita > 10">
                            <img src="./assets/images/Semaforo-rosso.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita == 0">
                        
                                  
                                <ng-container *ngIf="prodotto.InPromo != 0">
                                    &nbsp; € {{prodotto.prezzoPromo}} <span *ngIf="estero != 'SI'">(€ {{prodotto.prezzoPromoIvato}})</span>
                                </ng-container>

                                <ng-container *ngIf="prodotto.InPromo == 0">
                                    &nbsp; € {{prodotto.prezzo}} <span *ngIf="estero != 'SI'">(€ {{prodotto.prezzoIvato}})</span>
                                </ng-container>
                                
                                </div>
                                <!--<div class="product-price"><ins>Accedi</ins>
                                </div> -->
                            </div>
                        </div> 
                    </div>
                    <!-- FINE SINGOLO PRODOTTO -->

                </ng-container>
                
                <table class="table table-striped" *ngIf="typeVis == 'list'">
                    <thead>
                    <tr>
                        <th></th>
                        <th>EAN</th>
                        <th>Pz CArtone</th>
                        <th>Prodotto</th>
                        <th>Tipo</th>
                        <th *ngIf="loggato"></th>
                        <th *ngIf="loggato">Prezzo</th>
                        <th *ngIf="loggato">Prezzo Ivato</th>
                        <th style="width: 120px;" *ngIf="loggato">Quantità</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let prodotto of arrProdotti; index as i" >
                        <td><img style="width: 50px;" alt="Nome immagine" src="{{prodotto.img1}}"></td>
                        <td><a (click)="openModal(prodotto.idprod);">{{prodotto.ean}}</a></td>
                        <td><a (click)="openModal(prodotto.idprod);">{{prodotto.cartone}} pz</a></td>
                        <td><a (click)="openModal(prodotto.idprod)">{{prodotto.titolo}}</a></td>
                        <td><span class="ean-prodotto" *ngIf="prodotto.tipoprod == 'c'">Canvas e Listino</span>
                            <span class="ean-prodotto" *ngIf="prodotto.tipoprod == 'v'">Volantino</span></td>
                        <td *ngIf="loggato">
                            <img src="./assets/images/Semaforo-arancio.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita >= 1 && prodotto.disponibilita <= 10">
                            <img src="./assets/images/Semaforo-verde.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita > 10">
                            <img src="./assets/images/Semaforo-rosso.png" class="img-disp" alt="Prodotto disponibile" *ngIf="prodotto.disponibilita == 0">
        
                            </td>
                        <td *ngIf="loggato">€ {{prodotto.prezzo}} </td>
                        <td *ngIf="loggato">€ {{prodotto.prezzoIvato}} </td>
                        <td *ngIf="loggato && prodotto.vendibile == 1"> <div class="cart-product-quantity qty-box" >
                            <div class="quantity">
                                <input type="button" class="minus" value="-" (click)="removeQty(i)">
                                <input type="text" class="qty" value="1" name="quantity" [(ngModel)]="prodotto.qty">
                                <input type="button" class="plus" value="+" (click)="addQty(i)">
                            </div>
                            
                        </div>
                        </td>
                        <td>
                            <a *ngIf="loggato && prodotto.vendibile == 1" class="btn" (click)="addCart(prodotto, i)"><span class="material-icons icoCart">
                                add_shopping_cart
                                </span></a>

                                <button class="btn btn-block mt-3 btn-danger" routerLink="/accedi" *ngIf="!loggato">ACCEDI</button>
                        </td>
                    </tr>
                </tbody>
                </table>
            
            <hr>
                
                

            </div>
        </div>
    </div>
</section>
<!-- end: Shop products -->

<app-modal-scheda-prod3 #modal [modalConfig3]="modalConfig3">
    <app-scheda-prodotto #schedaProd [idProdotto]="idProdotto" (childEvent)="closeModal($event)"></app-scheda-prodotto>
  </app-modal-scheda-prod3>